/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonPrimary } from '../../../../../../utils/Button';
import { GetDate } from '../../../../../../utils/Show';
import { mkRelativeUrl } from '../../../../../../utils/URL';
import cn from '../../../../../../utils/cn';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`value-text line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item }) {
    const navigate = useNavigate();
    const [isActive, setIsActive] = useState(false);

    const handleView = (ev) => {
        ev.stopPropagation();
        navigate(mkRelativeUrl(`/billing/invoices/${item?.invoiceId}/info`));
    };

    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsActive(!isActive)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-72': isActive,
                    'max-h-10': !isActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.currency}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span
                        className={`line-clamp-1 capitalize ${
                            item?.status === 'paid' ? 'text-success' : 'text-warning'
                        }`}
                    >
                        {item?.status}
                    </span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard
                    name="Status"
                    value={item?.status}
                    isCapitalize
                    className={`sm:hidden ${item?.status === 'paid' ? '[&>.value-text]:text-success' : '[&>.value-text]:text-warning'}`}
                />
                <TableInfoCard name="Invoice ID" value={item?.invoiceId} />
                <TableInfoCard name="Initiate Date" value={GetDate(item?.timeInitiate)} />
                <TableInfoCard name="Success Date" value={GetDate(item?.timeSuccess)} />
                <TableInfoCard name="Amount" value={item?.amount} />

                <div className="flex flex-row gap-px justify-end items-center">
                    <ButtonPrimary
                        btnType="button"
                        title="View"
                        onClick={handleView}
                        className="h-7 min-w-14 text-sm"
                    />
                </div>
            </div>
        </div>
    );
}

function TableMobile({ data }) {
    return (
        <div className="payments_page_mobile_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data && data?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Payment Found</div>
                ) : (
                    data?.map((item) => <TableRow key={item.id} item={item} />)
                )}
            </div>
        </div>
    );
}

export default TableMobile;
